export enum LeaveType {
  ANNUAL_LEAVE = 'ANNUAL_LEAVE',
  SICK_LEAVE = 'SICK_LEAVE',
  COMPASSIONATE_LEAVE = 'COMPASSIONATE_LEAVE',
  MARRIAGE_LEAVE = 'MARRIAGE_LEAVE',
  PATERNITY_OR_MATERNITY = 'PATERNITY_OR_MATERNITY',
  HOSPITALIZATION_LEAVE = 'HOSPITALIZATION_LEAVE',
  OTHER = 'OTHER',
}
